export default __webpack_public_path__ + "bb76872ad7e3ac379de0f37776109fe3.png";